import React from 'react'
import { Dropdown, Menu } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import * as DROPDOWN from 'constant/dropdown'
import EditInsight from 'view/page/insight-management/component/edit-insight'
import formatArticle from 'helper/format-input-fields'
import PropTypes from 'prop-types'
import EditAuthor from 'view/component/table-columns/common-actions/edit-author'
import DeleteInsight from './component/delete'
import PinInsight from './component/pin'
import PublishInsight from './component/publish'
import styles from './styles'

const Action = ({ insight }) => (
  <span>
    <Dropdown
      overlay={
        <Menu>
          <Menu.Item>
            <EditInsight insight={formatArticle(insight)} />
          </Menu.Item>
          <Menu.Item>
            <DeleteInsight insight={insight} />
          </Menu.Item>
          <Menu.Item>
            <PublishInsight insight={insight} />
          </Menu.Item>
          <Menu.Item>
            <PinInsight insight={insight} />
          </Menu.Item>
          <Menu.Item>
            <EditAuthor article={formatArticle(insight)} />
          </Menu.Item>
        </Menu>
      }
      overlayStyle={{ zIndex: 1 }}
      trigger={[DROPDOWN.TRIGGER]}
    >
      <div className={styles.show_more}>
        <span>More</span>
        <DownOutlined />
      </div>
    </Dropdown>
  </span>)

Action.propTypes = {
  insight: PropTypes.object
}

export default Action
